import { useRef } from 'react';
import {
  Box,
  Table,
  Pagination,
  TextInput,
  Button,
  MediaQuery
} from '@mantine/core';
import { BiDollar } from 'react-icons/bi';
import jsPDF from 'jspdf';
import invoice from '../../../assets/icons/invoiceIcon.svg';

import { useStyles } from './style';
import edit from '../../../assets/icons/edit.svg';
import view from '../../../assets/icons/view.svg';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SearchIcon } from '../../../assets/icons/search';
import { data, statusClass, propertiesUserType } from './properties';
import { baseURL } from '../../../config/urls';
import html2pdf from 'html2pdf.js';

import {
  getHeader,
  doRedirectIfUnAuth,
  getUserType,
  getUserData
} from '../../../config/userSession';
import plusIcon from '../../../assets/icons/plus-icon.svg';
import { IconCheck, IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { noRecordFound } from '../../../utils/const';
import { useLocation } from 'react-router-dom';
import handleSearch from '../../common/Search';
import dayjs from 'dayjs';
import CustomTooltip from '../../tenant/PaymentDue/CustomTooltip';
import { useGetUser } from '../../../hooks/use-get-user';

function InvoiceList() {
  const userType = getUserType();
  const { classes, theme } = useStyles(useStyles);
  const [activePage, setActivePage] = useState(1);
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [pageLoadEntries, setPageLoadEntries] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const cacheListing = useRef({});
  const params = new URLSearchParams();
  const userData = useGetUser();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');

  params.append('page', activePage);
  params.append('pSize', pageSize);
  params.append('email', email);

  const pageChangeHandler = (page) => {
    setActivePage(page);
  };

  const fetchContactForm = async () => {
    if (params in cacheListing) {
      setEntries(cacheListing[params]);
      setPageLoadEntries(cacheListing[params]);
      return;
    }

    let url;
    if (userType === 'Manager') {
      url = `${baseURL}/invoice/get-manager-payment-invoice?`;
    } else {
      url = `${baseURL}/invoice/get-payment-invoice?`; // ✅ Fixed here
    }

    const response = await fetch(url + '?' + params.toString(), {
      method: 'GET',
      headers: getHeader()
    });
    if (response.ok) {
      let contactFormListing = await response.json();
      setEntries(contactFormListing.invoices);
      setPageLoadEntries(contactFormListing.invoices);
      setTotalPage((contactFormListing.totalCount + pageSize - 1) / pageSize);
      cacheListing[params] = contactFormListing.invoices;
    } else {
      doRedirectIfUnAuth(response.status);
    }
  };

  useEffect(() => {
    fetchContactForm();
  }, [activePage]);
  const getBase64ImageFromURL = async (url) => {
    const res = await fetch(url, { mode: 'cors' });
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => reject('Error loading image');
      reader.readAsDataURL(blob);
    });
  };
  const generateInvoicePDF = async (element) => {
    const {
      invoiceId: invoiceNumber,
      lineItems: parseotherPayment,
      logoUrl: logo,
      createdAt: rentDate,
      dueDate: formattedDate
    } = element;
    const rentAmount = Number(element.rentAmount);
    const otherPayment = JSON.parse(parseotherPayment);
    const companyName = element?.Property.User.companyName;
    const companyAddress = element?.Property.addressLine1;
    const companyCity = element?.Property.city;
    const companyPhone = element.Property.User.phoneNumber;
    const companyEmail = element.Property.User.email;
    const rentPeriod = rentDate;

    const total =
      rentAmount + otherPayment.reduce((acc, b) => acc + Number(b.amount), 0);

    const clientInfo = `
      <p><strong>${
        element.Property.tenantCompanyName
          ? element.Property.tenantCompanyName
          : element.Property.tenantName
      }</strong><br>
     ${element?.Property.addressLine1}<br>
     ${element?.Property.city}<br>
      </p>
    `;
    let base64Logo = '';
    if (logo) {
      try {
        base64Logo = await getBase64ImageFromURL(logo);
      } catch (err) {
        console.warn('Logo could not be loaded:', err);
      }
    }
    const htmlContent = `
      <html>
      <head>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { font-family: 'Arial', sans-serif; font-size: 16px; line-height: 1.4; color: #333; background: white; }
          .invoice-container { padding: 40px; max-width: 800px; margin: 0 auto; }
          .logo-container { text-align: right; margin-bottom: 20px; }
          .company-logo { height: 100px; object-fit: contain; }
          .invoice-info { margin-bottom: 40px; }
          .invoice-info p { font-size: 14px; margin-bottom: 8px; font-weight: 500; }
          .header { display: flex; justify-content: space-between; margin-bottom: 25px; border-bottom: 2px solid #000; padding-bottom: 15px; }
          .company-info h2 { font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #000; }
          .company-info p, .client-info p { font-size: 14px; line-height: 1.4; }
          .payment-link { margin: 20px 0; }
          .pay-now-link { color: #0066cc; text-decoration: underline; font-weight: 500; }
          .items-table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
          .items-table th, .items-table td { border: 1px solid #000; padding: 12px 8px; font-size: 14px; }
          .amount-cell { text-align: right; font-family: 'Courier New', monospace; }
          .total-row { background-color: #f0f0f0; font-weight: bold; }
          .thank-you { text-align: center; font-style: italic; margin: 20px 0; font-size: 14px; color: #666; }
        </style>
      </head>
      <body>
        <div class="invoice-container">
          <div class="logo-container">
         ${
           base64Logo
             ? `<img src="${base64Logo}" alt="Company Logo" class="company-logo" />`
             : ''
         }
          </div>

          <div class="invoice-info">
            <p>Invoice number: ${invoiceNumber}</p>
            <p>Date of issue: ${dayjs(rentDate).format('MM/DD/YYYY')}</p>
            <p>Date due: ${dayjs(formattedDate).format('MM/DD/YYYY')}</p>
          </div>

          <div class="header">
            <div class="company-info">
              <h2>${companyName}</h2>
              <p>${companyAddress}<br>${companyCity}<br>${companyPhone}<br>${companyEmail}</p>
            </div>
            <div class="client-info">${clientInfo}</div>
          </div>


          <table class="items-table">
            <thead>
              <tr>
                <th style="width: 45%;">DESCRIPTION</th>
                <th style="width: 25%;">Date</th>
                <th style="width: 30%;">AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Rent for <br>${element.month}</td>
                  <td>${dayjs(rentDate).format('MM/DD/YYYY')}</td>
                <td class="amount-cell">$${rentAmount.toFixed(2)}</td>
              </tr>
              ${otherPayment
                .map(
                  (item) => `
                <tr>
                  <td>${item.description}</td>
                  <td>${dayjs(rentDate).format('MM/DD/YYYY')}</td>
                  <td class="amount-cell">$${Number(item.amount).toFixed(
                    2
                  )}</td>
                </tr>`
                )
                .join('')}
              <tr class="total-row">
                <td>Total</td>
                <td></td>
                <td class="amount-cell">$${total.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <div class="thank-you">
            <em>Thank you for your business!</em>
          </div>
        </div>
      </body>
      </html>`;

    // Convert string to DOM node
    const container = document.createElement('div');
    container.innerHTML = htmlContent;

    html2pdf()
      .set({
        margin: 0,
        filename: `invoice-${invoiceNumber}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      })
      .from(container)
      .save();
  };

  const rows = entries.map((element, index) => {
    const ccEmails = JSON.parse(element.ccMails);
    const formatted = ccEmails.join(',  \n');
    return (
      <tr
        className={index % 2 === 0 ? classes.tableRowWhite : classes.tableRow}
        key={`${element.invoiceId}${index}`}
      >
        <td className={classes.tableData}>{element.Property.propertName}</td>
        <td className={classes.tableData}>{element.To}</td>
        <td className={classes.tableData}> {element.sentBy}</td>
        {userType !== propertiesUserType.tenant && (
          <td className={classes.tableData}>{element.month}</td>
        )}
        {ccEmails.length > 1 ? (
          <td className={classes.tableData}>
            <td className={classes.tableData}>{formatted}</td>
          </td>
        ) : (
          <td className={classes.tableData}>{ccEmails}</td>
        )}
        <td className={classes.tableData}>
          {dayjs(element.createdAt).format('MM/DD/YYYY')}
        </td>
        <td className={classes.tableData}>
          <Button onClick={() => generateInvoicePDF(element)} variant="subtle">
            {' '}
            <img
              width="26px"
              height="26"
              style={{ cursor: 'pointer' }}
              src={invoice}
              alt="invoice"
            />
          </Button>
        </td>
      </tr>
    );
  });

  const showNotification = (notificationType, message, title, width) => {
    let colorCode = notificationType === 'success' ? 'secondary.0' : 'red';

    notifications.show({
      id: 'invoice-notification',
      withCloseButton: true,
      title: title,
      message: message,
      autoClose: false,
      color: colorCode,
      icon:
        notificationType === 'success' ? (
          <IconCheck size="2.5rem" />
        ) : (
          <IconX size="2.5rem" />
        ),
      style: {
        backgroundColor: theme.colors.background[0],
        padding: '12px 12px',
        fontSize: '8rem',
        lineHeight: '1.2',
        minHeight: '120px',
        width: width, // 👈 Set desired width here
        maxWidth: '90%' // Optional: responsive on smaller screens
      },
      styles: {
        title: {
          fontSize: '1.5rem',
          lineHeight: 1.3
        },
        description: {
          fontSize: '1.2rem',
          lineHeight: 1.4
        },
        closeButton: {
          color: 'white',
          backgroundColor: 'black',
          '&:hover': {
            backgroundColor: 'gray', // Change to your preferred hover color
            color: 'yellow' // Example hover text color
          }
        }
      }
    });
  };

  const handleAddNewProperty = async () => {
    const response = await fetch(
      `${baseURL}/account/getStripeConnectAccountStatus`,
      {
        method: 'GET',
        headers: getHeader()
      }
    );
    let connectStatus = await response.json();
    if (response.status === 200) {
      navigate('/landlord/add-property');
    } else {
      navigate('/landlord/profile');
      showNotification('failure', connectStatus.message, '', '550px');
    }
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.headerAndSearch}>
        <p className={classes.title}>{data.titles.propertyList}</p>
        <Box className={classes.searchAndFilter}>
          <TextInput
            icon={<SearchIcon />}
            onChange={(e) =>
              handleSearch(e, pageLoadEntries, setEntries, [
                'propertType',
                'status',
                'sentBy',
                'landlordName',
                'To'
              ])
            }
            radius={'xl'}
            className={classes.searchInput}
            placeholder={data.titles.search}
          />
        </Box>
        {userType === propertiesUserType.landlord ? (
          <MediaQuery query="(min-width: 500px)" styles={{ display: 'none' }}>
            <Button
              onClick={() => handleAddNewProperty()}
              color="primary.0"
              variant="white"
              radius="16px"
              size="lg"
              fullWidth={true}
            >
              {' '}
              <img
                className={classes.plusIcon}
                src={plusIcon}
                alt="plus-icon"
              />
              {data.cta.addProperty}
            </Button>
          </MediaQuery>
        ) : (
          ''
        )}
      </Box>
      <Box className={classes.tableContainer}>
        <Table className={classes.table}>
          <thead className={classes.tableHead}>
            <tr>
              {data.tableHeading[userType.toLowerCase()].map((heading) => {
                return <th className={classes.columnHeading}>{heading}</th>;
              })}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      </Box>
      {rows.length === 0 ? (
        <p className="no-record-found">{noRecordFound}</p>
      ) : (
        <Pagination
          size={'md'}
          defaultValue={activePage}
          onChange={pageChangeHandler}
          className={classes.pagination}
          siblings={1}
          total={totalPage}
        />
      )}
    </Box>
  );
}

export default InvoiceList;
